import {SocialType} from 'constants/socialType';
import {DeviceTypeType} from 'constants/platformType';

export enum UserStatus {
    WAITING = 'WAITING',
    NORMAL = 'NORMAL',
    SUSPENDED = 'SUSPENDED',
    WITHDRAWAL = 'WITHDRAWAL',
}
export interface User {
    id: number;
    name: string;
    email: string;
    imageUrl: string | null;
    status: UserStatus;
    lastLoginDateTime: string;
    signUpDateTime: string;
    socialType: SocialType;
    phoneNumber: string;
}

export enum MessageType {
    //이미지 픽커 관련
    OPEN_IMAGE_CALLBACK = 'OPEN_IMAGE_CALLBACK', // 이미지 픽커 콜백
    OPEN_GALLERY = 'OPEN_GALLERY', // 갤러리 열기
    OPEN_CAMERA = 'OPEN_CAMERA', // 카메라 열기
    GET_IMAGE_RESULT = 'GET_IMAGE_RESULT', // 이미지 수신 결과 디버깅용
    //인증 관련
    APP_SEND_TOKEN = 'APP_SEND_TOKEN', // 앱-> 웹뷰 토큰 전송
    WEB_SEND_TOKEN = 'WEB_SEND_TOKEN', // 웹뷰-> 앱 토큰 전송 (로그인 성공, 토큰 갱신 등)
    WEB_REQUEST_TOKEN = 'WEB_REQUEST_TOKEN', // 웹뷰-> 앱 토큰 요청
    WEB_LOGOUT = 'WEB_LOGOUT', // 웹뷰-> 앱 로그아웃

    // 푸시알림 관련
    GET_NOTIFICATION_TOKEN = 'GET_NOTIFICATION_TOKEN', // FE->RN
    GET_NOTIFICATION_TOKEN_CALLBACK = 'GET_NOTIFICATION_TOKEN_CALLBACK', // RN->FE
    GET_NOTIFICATION_TOKEN_RESULT = 'GET_NOTIFICATION_TOKEN_RESULT', // FE->RN 토큰 저장 api 호출 결과

    // 알림 권한 관련
    UPDATE_NOTIFICATION_PERMISSION = 'UPDATE_NOTIFICATION_PERMISSION', // FE->RN 알림 권한 변경 요청
    UPDATE_NOTIFICATION_PERMISSION_RESULT = 'UPDATE_NOTIFICATION_PERMISSION_RESULT', // RN->FE 알림 권한 변경 결과

    // 결제 관련
    REQUEST_PAYMENT = 'REQUEST_PAYMENT', // FE->RN 결제 요청
    REQUEST_PAYMENT_CALLBACK = 'REQUEST_PAYMENT_CALLBACK', // RN->FE 결제 결과 콜백
}

// 토큰 관련 메시지 인터페이스
export interface TokenMessagePayload {
    accessToken: string;
    refreshToken: string;
}

export interface AppSendTokenMessage {
    type: MessageType.APP_SEND_TOKEN;
    payload: TokenMessagePayload;
}

export interface WebSendTokenMessage {
    type: MessageType.WEB_SEND_TOKEN;
    payload: TokenMessagePayload;
}

export interface WebRequestTokenMessage {
    type: MessageType.WEB_REQUEST_TOKEN;
}

export interface WebLogoutMessage {
    type: MessageType.WEB_LOGOUT;
}

export interface PushTokenResultMessage {
    type: MessageType.GET_NOTIFICATION_TOKEN_RESULT;
    payload: {
        success: boolean;
        token: string;
        deviceType: DeviceTypeType;
        timestamp: string;
    };
}

// 결제 관련 메시지 인터페이스
export interface RequestPaymentMessage {
    type: MessageType.REQUEST_PAYMENT;
    channelKey: string;
    currency: string;
    easyPay: string | null;
    orderId: number;
    orderName: string;
    payMethod: string;
    paymentId: string;
    storeId: string;
    totalAmount: number;
}

export interface RequestPaymentCallbackMessage {
    type: MessageType.REQUEST_PAYMENT_CALLBACK;
    result: 'success' | 'failure';
}

export type AuthMessage =
    | AppSendTokenMessage
    | WebSendTokenMessage
    | WebRequestTokenMessage
    | WebLogoutMessage
    | PushTokenResultMessage
    | RequestPaymentMessage
    | RequestPaymentCallbackMessage;
